module.exports = __webpack_public_path__ + "static/why-your-business-eeds@2x-6a0358c8c90051a857c9b7c9c5a192de.jpg";